import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { deleteTrainingSessionTplPhase, getTrainingSessionTplPhaseSingle } from "../../../../services/training-session-tpl";
import { emptyTrainingSessionPhaseTpl, TrainingSessionPhaseTpl } from "../../../../interfaces/training-session-tpl";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface CoachTrainingSessionTplPhaseDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionTplPhaseDelete(props: CoachTrainingSessionTplPhaseDeleteProps) {
    const [trainingSessionTplPhase, setTrainingTplPhase] = useState<TrainingSessionPhaseTpl>(emptyTrainingSessionPhaseTpl);

    const handleDelete = () => {
        deleteTrainingSessionTplPhase(props.id)
            .then(response => {
                props.onDelete(props.id);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getTrainingSessionTplPhaseSingle(props.id)
            .then(response => {
                setTrainingTplPhase(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="training-tpl-phase-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_training_session_phase_tpl") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { trainingSessionTplPhase.id == 0 && 
                    <LoadingSpinner />
                }
                { trainingSessionTplPhase.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_training_session_phase_tpl_message"
                                values={{
                                    training_session_tpl_phase_name: trainingSessionTplPhase.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}